import React from "react";
import useStyles from "./styles";
import { VoyageMap } from "Components/Tracking/Map";
import LabelForm from "Components/Form/Label";
import VoyageDetails from "Components/VoyageDetailsComponent";
import { ContainerPosition, ContainerStatus } from "Models/marine.traffic";

export default function VoyagesSection() {
  const classes = useStyles();

  const containerStatus: ContainerStatus = {
    originPortName: "Port",
    finalPortName: "Santos",
    finalPortCarrierEstimatedArrivalUtc: "2025-06-01T15:00:00Z",
    finalPortPredictiveArrivalUtc: "2025-06-02T14:00:00Z",
    finalPortActualArrivalUtc: undefined,
    finalPortLocalTimeOffset: -3,
    finalPortId: 101,
    nextPortId: 102,
    nextPortName: "Santos",
    scac: "MSC",
    shipmentId: "SHIP123",
    transportDocumentId: "TD456",
    transportDocumentType: "BL",
    vesselIMONumber: 9484572,
    vesselName: "MSC Fantasia",
    vesselType: "Container",
    vesselShipId: 8901,
    transportationPlan: {
      routes: [],
      events: [],
      locations: [],
      transportLegs: [],
      vessels: [],
    },
  };

  const containerPosition: ContainerPosition = {
    MMSI: "563052700",
    LAT: "-23.965",
    LON: "-46.333",
    SPEED: "102",
    HEADING: "219",
    COURSE: "221",
    STATUS: "Underway",
    TIMESTAMP: "2025-05-23T12:30:00Z",
    SHIPNAME: "MSC Fantasia",
    SHIPTYPE: "70",
    TYPE_NAME: "Container Ship",
    AIS_TYPE_SUMMARY: "Cargo",
    IMO: "9484572",
    CALLSIGN: "9V6246",
    FLAG: "SG",
    PORT_ID: null,
    PORT_UNLOCODE: null,
    CURRENT_PORT: null,
    LAST_PORT_ID: "2727",
    LAST_PORT_UNLOCODE: "DEHAM",
    LAST_PORT: "Hamburgo",
    LAST_PORT_TIME: "2025-05-18T10:00:00Z",
    DESTINATION: "Santos",
    ETA: "2025-06-01T15:00:00Z",
    ETA_CALC: "2025-06-01T18:00:00Z",
    LENGTH: "300",
    WIDTH: "48",
    DRAUGHT: "140",
    GRT: "98000",
    NEXT_PORT_ID: "1002",
    NEXT_PORT_UNLOCODE: "BRSSZ",
    NEXT_PORT_NAME: "Santos",
    NEXT_PORT_COUNTRY: "Brazil",
    DWT: "110000",
    YEAR_BUILT: "2012",
    DSRC: "SAT",
  };

  const shipment = {
    billOfLanding: "BL1234567890",
    bookingNo: "BK987654321",
    containerNumbers: "CONT-1234567",
    shipmentTracking: {
      shipmentStatus: "IN_TRANSIT",
      nextPortName: "Santos",
    },
  };

  return (
    <>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>VoyageMap</LabelForm>
        </div>
        <VoyageMap
          information={{
            vesselName: "Ever Given",
            position: {
              lat: 30.0444,
              lng: 31.2357,
            },
            lastUpdate: new Date().toISOString(),
            speed: "12.5",
          }}
        />
        <hr />
      </div>
      <div>
        <div>
          <LabelForm className={classes.formLabel}>VoyageDetails</LabelForm>
        </div>
        <VoyageDetails
          shipment={shipment}
          containerStatus={containerStatus}
          containerPosition={containerPosition}
          isOnViewComponent={false}
          viewLivePosition={true}
        />
        <hr />
      </div>
    </>
  );
}
